import { combineReducers } from 'redux';
import navReducer from './navReducer';
import toggleReducer from './toggleReducer';
import sectionReducer from './sectionReducer';
import paymentReducer from './paymentReducer';
import signupReducer from './signupReducer';
import userReducer from './userReducer';
import commentReducer from './commentReducer';
import roomReducer from './roomReducer';
import messageIdReducer from './messageIdReducer';
import workspaceReducer from './workspaceReducer';
import projectReducer from './projectReducer';
import chatReducer from './chatRoomReducer';
import searchReducer from './searchReducer';
import notificationReducer from '../redux/state-areas/notifications/notificationsSlice';
import calendarReducer from './calendarReducer';
import messageReducer from './messageReducer';
import teamReducer from './teamReducer';
import modalReducer from './modalReducer';
import aiReducer from './aiReducer';
import inviteReducer from './inviteReducer';
import onboardingReducer from './onboardingReducer';
import orgReducer from './orgReducer';
import entities from '../redux/entities';
import generalReducer from '../redux/general/reducers';
import { tasksApi } from '../services/tasksApi';
import filesReducer from '../redux/files/reducers';
import tasks from '../redux/tasks/reducers';
import { formsApi } from '../services/formsApi';
import { projectsApi } from '../services/projectsApi';
import socket from '../redux/state-areas/socket/reducers';
import { customFieldsApi } from '../services/customFieldsApi';
import { workspacesApi } from '../services/workspacesApi';
import { workspacePaymentApi } from '../services/workspacePaymentApi';
import { productsPaymentApi } from '../services/productsPaymentApi';
import { remindersApi } from '../services/remindersApi';
import { personalAccessTokensApi } from '../services/personalAccessTokensApi';
import infiniteListData from '../redux/state-areas/infinite-list-data/reducers';
import dashboards from '../redux/state-areas/dashboards/reducers';
import reports from '../redux/state-areas/reports/slice';

const rootReducer = combineReducers({
  projectReducer: projectReducer,
  workspaceReducer: workspaceReducer,
  messageIdReducer: messageIdReducer,
  roomReducer: roomReducer,
  inviteReducer: inviteReducer,
  commentReducer: commentReducer,
  userReducer: userReducer,
  signupReducer: signupReducer,
  navReducer: navReducer,
  toggleReducer: toggleReducer,
  sectionReducer: sectionReducer,
  paymentReducer,
  chatReducer,
  searchReducer,
  notificationReducer,
  calendarReducer,
  messageReducer,
  teamReducer,
  modalReducer,
  aiReducer,
  onboardingReducer,
  orgReducer,
  entities,
  generalReducer,
  tasks,
  [tasksApi.reducerPath]: tasksApi.reducer,
  [projectsApi.reducerPath]: projectsApi.reducer,
  filesReducer,
  [formsApi.reducerPath]: formsApi.reducer,
  [customFieldsApi.reducerPath]: customFieldsApi.reducer,
  [workspacesApi.reducerPath]: workspacesApi.reducer,
  [workspacePaymentApi.reducerPath]: workspacePaymentApi.reducer,
  [productsPaymentApi.reducerPath]: productsPaymentApi.reducer,
  [remindersApi.reducerPath]: remindersApi.reducer,
  [personalAccessTokensApi.reducerPath]: personalAccessTokensApi.reducer,
  socket,
  infiniteListData,
  dashboards,
  reports,
});

export default rootReducer;
